import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddEducation, IEducation } from "../../Education.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useAddEducation = () => {
  const [formData, setFormData] = useState<IAddEducation>({
    languageName: "",
    courseName: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [education, setEducation] = useState<IEducation | null>(null);
  const [educationData, setEducationData] = useState<IEducation[]>([]); // State to hold fetched educations
  const [courses, setCourses] = useState<any[]>([]);
  const [languages, setLanguages] = useState<any[]>([]);
  const navigate = useNavigate();

  // Fetch data when the component mounts
  useEffect(() => {
    fetchData();
  }, []);

  // Fetch education data
  const fetchData = async () => {
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: apiPaths.getStandard,
      });
      setEducationData(result); // Set the fetched education data
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch education data."); // Show error toast
    }
  };

  // Fetch courses and languages data
  const fetchCoursesAndLanguages = async () => {
    try {
      setLoading(true);
      const [languagesResponse] = await Promise.all([
        ApiService({ method: "GET", endpoint: apiPaths.getStandards }),
      ]);
      setLanguages(languagesResponse);
    } catch (error) {
      console.error("Error fetching courses and languages:", error);
      toast.error("Failed to fetch courses or languages."); // Show error toast
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit: SubmitHandler<IAddEducation> = async () => {
    try {
      const response = await ApiService({
        method: "POST",
        endpoint: `${apiPaths.createStandard}`,
        data: {
          standard: formData.courseName,
        },
      });

      toast.success("Education added successfully", {
        duration: 10000,
      });
      navigate("/education"); 
    } catch (error) {
      toast.error("Error updating status", {
        duration: 10000,
      });
      console.error("Error updating education:", error);
    }
  };

  const handleCancel = () => {
    navigate("/education");
  };

  return {
    loading,
    formData,
    education,
    educationData,
    languages,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useAddEducation;
